import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5677a52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-layout" }
const _hoisted_2 = { class: "dashboard-header flex align-items-center justify-content-between flex-wrap gap-3 mb-3" }
const _hoisted_3 = { class: "flex flex-column gap-1" }
const _hoisted_4 = { class: "text-sm text-color-secondary" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex align-items-center gap-2 flex-wrap" }
const _hoisted_7 = { class: "flex align-items-center gap-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-color-secondary" }, "Auto (45s)", -1))
const _hoisted_9 = {
  key: 0,
  class: "dashboard-loading flex align-items-center justify-content-center py-6"
}
const _hoisted_10 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-calendar-blank dash-empty-icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No billing periods found. Create a period to get started.", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "dashboard-section mb-3"
}
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-sm text-color-secondary"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "dashboard-split mb-3" }
const _hoisted_19 = {
  key: 0,
  class: "dashboard-panel"
}
const _hoisted_20 = {
  key: 1,
  class: "dashboard-panel"
}
const _hoisted_21 = { class: "dashboard-split mb-3" }
const _hoisted_22 = {
  key: 0,
  class: "dashboard-panel"
}
const _hoisted_23 = {
  key: 1,
  class: "dashboard-panel"
}
const _hoisted_24 = { class: "dashboard-split mb-3" }
const _hoisted_25 = {
  key: 0,
  class: "dashboard-panel"
}
const _hoisted_26 = {
  key: 1,
  class: "dashboard-panel"
}
const _hoisted_27 = { class: "dashboard-split mb-3" }
const _hoisted_28 = {
  key: 0,
  class: "dashboard-panel"
}
const _hoisted_29 = {
  key: 1,
  class: "dashboard-panel"
}
const _hoisted_30 = {
  key: 1,
  ref: "settlementPanel",
  class: "dashboard-panel mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PDropdown = _resolveComponent("PDropdown")!
  const _component_PInputSwitch = _resolveComponent("PInputSwitch")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PProgressSpinner = _resolveComponent("PProgressSpinner")!
  const _component_DashKpiStrip = _resolveComponent("DashKpiStrip")!
  const _component_DashActionQueue = _resolveComponent("DashActionQueue")!
  const _component_DashOpsPanel = _resolveComponent("DashOpsPanel")!
  const _component_DashEnergy = _resolveComponent("DashEnergy")!
  const _component_DashChartPr = _resolveComponent("DashChartPr")!
  const _component_DashPayments = _resolveComponent("DashPayments")!
  const _component_DashValidityHeatmap = _resolveComponent("DashValidityHeatmap")!
  const _component_DashShortcuts = _resolveComponent("DashShortcuts")!
  const _component_DashCoefficients = _resolveComponent("DashCoefficients")!
  const _component_DashSettlement = _resolveComponent("DashSettlement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_WTitle, { text: "Dashboard" }),
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(" Operational overview for the selected billing period "),
          (_ctx.lastUpdated)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · updated " + _toDisplayString(_ctx.lastUpdatedLabel), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_PDropdown, {
          disabled: _ctx.loading,
          options: _ctx.periodOptions,
          optionLabel: "label",
          optionValue: "value",
          placeholder: "Select billing period",
          style: {"min-width":"14rem"},
          modelValue: _ctx.billingPeriodId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.billingPeriodId) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPeriodChange()))
        }, null, 8, ["disabled", "options", "modelValue"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_PInputSwitch, {
            modelValue: _ctx.autoRefresh,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.autoRefresh) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_8
        ]),
        (_ctx.canRunPpm)
          ? (_openBlock(), _createBlock(_component_PButton, {
              key: 0,
              disabled: !_ctx.billingPeriodId || _ctx.runningPpm || _ctx.loading,
              loading: _ctx.runningPpm,
              icon: "pi pi-chart-line",
              label: "Run PPM",
              outlined: "",
              rounded: "",
              size: "small",
              severity: "success",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.runPpm()))
            }, null, 8, ["disabled", "loading"]))
          : _createCommentVNode("", true),
        (_ctx.canRunTcm)
          ? (_openBlock(), _createBlock(_component_PButton, {
              key: 1,
              disabled: !_ctx.billingPeriodId || _ctx.runningTcm || _ctx.loading,
              loading: _ctx.runningTcm,
              icon: "pi pi-play",
              label: "Run TCM",
              rounded: "",
              size: "small",
              severity: "success",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.runTcm()))
            }, null, 8, ["disabled", "loading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_PButton, {
          disabled: _ctx.loading,
          icon: "pi pi-refresh",
          label: "Refresh",
          outlined: "",
          rounded: "",
          size: "small",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.refresh()))
        }, null, 8, ["disabled"])
      ])
    ]),
    (_ctx.loading && !_ctx.payload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_PProgressSpinner, {
            strokeWidth: "4",
            style: {"width":"48px","height":"48px"}
          })
        ]))
      : (!_ctx.billingPeriodId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.payload?.kpis)
              ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                  _createVNode(_component_DashKpiStrip, {
                    kpis: _ctx.payload.kpis
                  }, null, 8, ["kpis"]),
                  (_ctx.showMissingEngines)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (!_ctx.payload.kpis.tcm_available && _ctx.canRunTcm)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "TCM has not been run for this period. "))
                          : _createCommentVNode("", true),
                        (!_ctx.payload.kpis.ppm_available && _ctx.canRunPpm)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "PPM has not been run for this period."))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.showActions)
                ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                    _createVNode(_component_DashActionQueue, {
                      actions: _ctx.payload?.actions || null,
                      busyAction: _ctx.actionBusy.action,
                      busyId: _ctx.actionBusy.id,
                      onApproveEntry: _cache[6] || (_cache[6] = ($event: any) => (_ctx.approveEntry($event))),
                      onApproveInvoice: _cache[7] || (_cache[7] = ($event: any) => (_ctx.approveInvoice($event))),
                      onRejectEntry: _cache[8] || (_cache[8] = ($event: any) => (_ctx.rejectEntry($event)))
                    }, null, 8, ["actions", "busyAction", "busyId"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showOps)
                ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
                    _createVNode(_component_DashOpsPanel, {
                      auditRecent: _ctx.payload?.audit_recent || null,
                      busyAction: _ctx.opsBusy,
                      dcs: _ctx.payload?.dcs || null,
                      health: _ctx.payload?.health || null,
                      mda: _ctx.payload?.mda || null,
                      scheduler: _ctx.payload?.scheduler || null,
                      telemetry: _ctx.payload?.telemetry || null,
                      onFlushTelemetry: _cache[9] || (_cache[9] = ($event: any) => (_ctx.flushTelemetry())),
                      onScheduler: _cache[10] || (_cache[10] = ($event: any) => (_ctx.schedulerControl($event)))
                    }, null, 8, ["auditRecent", "busyAction", "dcs", "health", "mda", "scheduler", "telemetry"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_ctx.showEnergy)
                ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
                    _createVNode(_component_DashEnergy, {
                      series: _ctx.payload?.energy_series || []
                    }, null, 8, ["series"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showPr)
                ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                    _createVNode(_component_DashChartPr, {
                      hourly: _ctx.payload?.ppm?.hourly || []
                    }, null, 8, ["hourly"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_ctx.showPayments)
                ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                    _createVNode(_component_DashPayments, {
                      series: _ctx.payload?.payments_series || []
                    }, null, 8, ["series"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showHeatmap)
                ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
                    _createVNode(_component_DashValidityHeatmap, {
                      cells: _ctx.payload?.validity_heatmap || []
                    }, null, 8, ["cells"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.showShortcuts)
                ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
                    _createVNode(_component_DashShortcuts, {
                      billingPeriodId: _ctx.billingPeriodId,
                      busy: _ctx.shortcutBusy !== '',
                      busyKey: _ctx.shortcutBusy,
                      canGenerateInvoice: _ctx.canGenerateInvoice,
                      canReports: _ctx.canReports,
                      chargeBreakdown: _ctx.payload?.charge_breakdown || [],
                      formulaSet: _ctx.payload?.formula_set || null,
                      timeline: _ctx.payload?.timeline || [],
                      onGenerateInvoice: _cache[11] || (_cache[11] = ($event: any) => (_ctx.generateInvoice())),
                      onReport: _cache[12] || (_cache[12] = ($event: any) => (_ctx.generateReport($event)))
                    }, null, 8, ["billingPeriodId", "busy", "busyKey", "canGenerateInvoice", "canReports", "chargeBreakdown", "formulaSet", "timeline"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showCoefficients)
                ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                    _createVNode(_component_DashCoefficients, {
                      coefficients: _ctx.payload?.coefficients || null
                    }, null, 8, ["coefficients"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.showSettlement)
              ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
                  _createVNode(_component_DashSettlement, {
                    approvingId: _ctx.approvingInvoiceId,
                    billingPeriodId: _ctx.billingPeriodId,
                    canApproveInvoice: _ctx.canApproveInvoice,
                    canRunTcm: _ctx.canRunTcm,
                    invoices: _ctx.payload?.invoices || [],
                    runningTcm: _ctx.runningTcm,
                    tcm: _ctx.payload?.tcm || null,
                    onApproveInvoice: _cache[13] || (_cache[13] = ($event: any) => (_ctx.approveInvoice($event))),
                    onRunTcm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.runTcm()))
                  }, null, 8, ["approvingId", "billingPeriodId", "canApproveInvoice", "canRunTcm", "invoices", "runningTcm", "tcm"])
                ], 512))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}